export type AddPrefix<TKey, TPrefix extends string> = TKey extends string
  ? `${TPrefix}${TKey}`
  : never;

export type AddSuffix<TKey, TSuffix extends string> = TKey extends string
  ? `${TKey}${TSuffix}`
  : never;

export type RemovePrefix<TPrefixedKey, TPrefix extends string> = TPrefixedKey extends AddPrefix<infer TKey, TPrefix>
  ? TKey
  : never;

export type AddPrefixToObject<TObject extends object, TPrefix extends string> = {
  [K in keyof TObject as K extends string ? AddPrefix<K, TPrefix> : never]:
  TObject[K]
}

export type KeysWithPrefix<TObject extends object, TPrefix extends string> = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  [K in keyof TObject]: K extends AddPrefix<infer _, TPrefix> ? K : never
}[keyof TObject]

export function TSAssertType<T>(_: any): asserts _ is T {}

export type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never;
